import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'

export default {
  components: {
    MenuComponent,
    MenuConnexion
  },
  data () {
    return {
      urlToCall: this.$store.state.user.user ? this.$store.state.user.user.lienMessagerie : '',
      cafToken: null,
      callToMessagerieDone: false,
      loading: true,
      iframeLoading: false,
      iframeCalculatedHeight: 'height: ' + window.innerHeight + 'px',
      intervalRelog: ''
    }
  },
  methods: {
    waitIframeLoading () {
      this.iframeLoading = true
      this.waitForIFrame()
    },
    waitForIFrame () {
      // eslint-disable-next-line
      $('#myFrame').on('load', function () {
        document.querySelector('#modalMessagerie').setAttribute('style', 'display: block;')
        // On retire le scroll du site principal
        window.scrollTo(0, 0)
        // eslint-disable-next-line
        $('body').css('overflow', 'hidden')
      })
      setTimeout(this.putTimerForLoading, 100)
    },
    putTimerForLoading () {
      this.iframeLoading = false
    },
    goBackToSite () {
      this.$router.push({ name: this.$store.state.user.user.firstPageUrl.toLowerCase() })
      if ('msSaveOrOpenBlob' in navigator) {
        // Pour IE, il faut un refresh pour que le scroll revienne, si si j'te jure
        location.reload()
      } else {
        // On remet le scroll du site principal
        // eslint-disable-next-line
        $('body').css('overflow', 'initial')
      }
    },
    calculateIFrameSize () {
      // On calcule la taille de la frame
      // On prend le bottom du sous menu - 24 qui est la taille du bouton "Retour Accueil"
      this.iframeCalculatedHeight = 'height: ' + (window.innerHeight - document.getElementById('sousMenuHeader').getBoundingClientRect().bottom - 24) + 'px'
    },
    onResize () {
      this.calculateIFrameSize()
    }
  },
  created () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeCreate () {
    this.callToMessagerieDone = false
    this.loading = true
    this.$store.dispatch('user/getTokenForMessagerie', this.$store.state.user.user.login).then(
      response => {
        this.cafToken = response
      },
      () => {
      })
  },
  updated () {
    if (this.cafToken && !this.callToMessagerieDone) {
      this.callToMessagerieDone = true
      // On declenche le post et l'envoi dans un nouvel onglet
      // eslint-disable-next-line
      $('#buttonMessagerie').click()
      this.calculateIFrameSize()

      // On place un boolean dans le store pour deconnecter le user
      this.$store.dispatch('user/userConnectionToMessagerie', true)

      // Refresh du cookie toutes les 55 minutes quand on est sur la messagerie
      this.intervalRelog = setInterval(() => {
        this.$store.dispatch('user/relogUserIfNecessary')
      }, 1000 * 60 * 55)

      this.loading = false
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.intervalRelog)
  }
}
